import styled from 'styled-components';

import { ContainerV2 } from '../../stories/atoms/containerV2/ContainerV2';

export const StyledScreenContainer = styled(ContainerV2)`
  height: 100vh;
  background-color: ${({ theme: { color, palette } }) => palette.mode === 'dark' && color.backgroundDark};
`;

export const StyledDropdowns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: ${({ theme: { spacing } }) => spacing(2)};
  margin-bottom: ${({ theme: { spacing } }) => spacing(4)};

  &:first-of-type {
    padding-top: ${({ theme: { spacing } }) => spacing(6)};
  }
`;
